import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";

export const getHasStateOrProvince = (country: string | undefined): boolean => {
  if (!country) {
    return true;
  }
  return (
    country === THREE_LETTER_PRIMARY_COUNTRY_CODES.USA ||
    country === THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN
  );
};
